var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Pluggable, useOkapiKy } from '@folio/stripes/core';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { HOME_PAGE_URL } from '../../constants';
import { useMessages, useRecordsLimit } from '../../hooks';
import { useQueryBuilderCommonSources } from '../../hooks/useQueryBuilderSources';
import { STATUS_VALUES, VISIBILITY_VALUES, } from '../../interfaces';
import { computeErrorMessage, t } from '../../services';
export var ConfigureQuery = function (_a) {
    var _b = _a.selectedType, selectedType = _b === void 0 ? '' : _b, _c = _a.isQueryButtonDisabled, isQueryButtonDisabled = _c === void 0 ? true : _c, _d = _a.listName, listName = _d === void 0 ? '' : _d, status = _a.status, visibility = _a.visibility, _e = _a.description, description = _e === void 0 ? '' : _e, _f = _a.isEditQuery, isEditQuery = _f === void 0 ? false : _f, listId = _a.listId, version = _a.version, recordColumns = _a.recordColumns, initialValues = _a.initialValues, _g = _a.setIsModalShown, setIsModalShown = _g === void 0 ? function () { return ({}); } : _g;
    var history = useHistory();
    var ky = useOkapiKy();
    var recordsLimit = useRecordsLimit();
    var _h = useMessages(), showSuccessMessage = _h.showSuccessMessage, showErrorMessage = _h.showErrorMessage;
    var _j = useState([]), columns = _j[0], setColumns = _j[1];
    var triggerButtonLabel = initialValues ? t('list.modal.edit-query') : undefined;
    var runQueryDataSource = function (_a) {
        var fqlQuery = _a.fqlQuery, queryId = _a.queryId;
        if (isEditQuery) {
            var data = {
                name: listName,
                description: description,
                fields: columns,
                isActive: status === STATUS_VALUES.ACTIVE,
                isPrivate: visibility === VISIBILITY_VALUES.PRIVATE,
                queryId: queryId,
                version: version,
                fqlQuery: JSON.stringify(fqlQuery),
            };
            return ky.put("lists/".concat(listId), { json: data }).json();
        }
        else {
            var data = {
                name: listName,
                description: description,
                fields: columns,
                isActive: status === STATUS_VALUES.ACTIVE,
                isPrivate: visibility === VISIBILITY_VALUES.PRIVATE,
                queryId: queryId,
                fqlQuery: JSON.stringify(fqlQuery),
                entityTypeId: selectedType,
            };
            return ky.post('lists', { json: data }).json();
        }
    };
    var onQueryRunSuccess = function (_a) {
        var id = _a.id;
        showSuccessMessage({
            message: t('callout.list.save.success', {
                listName: listName,
            }),
        });
        history.push("".concat(HOME_PAGE_URL, "/list/").concat(id));
    };
    var onQueryRunFail = function (error) {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var errorMessage;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, computeErrorMessage(error, 'update-optimistic.lock.exception', {
                            listName: listName,
                        })];
                    case 1:
                        errorMessage = _a.sent();
                        showErrorMessage({ message: errorMessage });
                        return [2 /*return*/];
                }
            });
        }); })();
    };
    var cancelQueryDataSource = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var queryId = _b.queryId;
        return __generator(this, function (_c) {
            return [2 /*return*/, ky.delete("query/".concat(queryId))];
        });
    }); };
    return (React.createElement(Pluggable, __assign({ componentType: "builder", type: "query-builder", recordColumns: recordColumns, onSetDefaultVisibleColumns: setColumns, key: selectedType, disabled: isQueryButtonDisabled, initialValues: initialValues, runQueryDataSource: runQueryDataSource, cancelQueryDataSource: cancelQueryDataSource }, useQueryBuilderCommonSources(selectedType), { onQueryRunSuccess: onQueryRunSuccess, onQueryRunFail: onQueryRunFail, recordsLimit: recordsLimit, saveBtnLabel: t('list.modal.run-query-and-save'), triggerButtonLabel: triggerButtonLabel, setIsModalShown: setIsModalShown })));
};
